import $ from "jquery";
window.$ = $;

import React from "react";
import { createRoot } from "react-dom/client";
import App from "~/bundles/App";
const container = document.getElementById("root");
const root = createRoot(container);
root.render(<App />);
